export const articles = [
  {
    id: 'article-1',
    slug: 'mogushipin-android-download-guide',
    title: '蘑菇视频App安卓版下载安装完整指南',
    excerpt: '详细介绍如何在安卓手机上安全下载、安装蘑菇视频App最新版本，包含常见安装问题解决方案。',
    content: `<h2>安卓版下载前准备</h2>
<p>在下载蘑菇视频App之前，建议您先做好以下准备工作，确保安装过程顺利：</p>
<ul>
<li>确保手机系统为Android 8.0及以上版本</li>
<li>手机存储空间至少保留200MB可用空间</li>
<li>保持网络连接稳定，建议使用Wi-Fi下载</li>
<li>在手机设置中开启「允许安装未知来源应用」选项</li>
</ul>
<h2>官方下载渠道</h2>
<p>为了您的账号安全和数据隐私，请务必通过以下官方渠道下载蘑菇视频App：</p>
<ul>
<li><strong>官方网站：</strong>访问蘑菇视频官方网站，点击「安卓下载」按钮获取最新APK安装包</li>
<li><strong>官方应用商店：</strong>在华为应用市场、小米应用商店、OPPO软件商店、vivo应用商店等主流安卓应用市场中搜索「蘑菇视频」下载</li>
<li><strong>第三方应用市场：</strong>在应用宝、360手机助手、百度手机助手等平台搜索下载</li>
</ul>
<h2>安装步骤详解</h2>
<p><strong>第一步：</strong>下载完成后，点击通知栏的下载完成提示，或进入文件管理器找到下载的APK文件。</p>
<p><strong>第二步：</strong>点击APK文件，系统会弹出安装确认窗口，点击「安装」按钮。</p>
<p><strong>第三步：</strong>等待安装进度条完成，大约需要30秒到1分钟。</p>
<p><strong>第四步：</strong>安装完成后，点击「打开」即可启动蘑菇视频App。</p>
<h2>安装常见问题</h2>
<h3>提示「安装包解析错误」怎么办？</h3>
<p>请检查下载的APK文件是否完整。建议删除后重新从官方渠道下载，确保下载过程没有被中断。</p>
<h3>提示「无法安装未知来源应用」？</h3>
<p>进入手机「设置」→「安全」或「隐私」，找到「未知来源」或「安装未知应用」选项，为浏览器或文件管理器开启权限即可。</p>
<h3>安装后闪退或无法打开？</h3>
<p>尝试清除应用缓存：设置 → 应用管理 → 蘑菇视频 → 存储 → 清除缓存。如问题持续，请卸载后重新安装。</p>`,
    category: 'download',
    categoryName: '下载安装',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20a%20colorful%20short%20video%20app%20interface%20with%20vibrant%20content%20thumbnails%2C%20clean%20minimal%20background%20with%20warm%20ambient%20lighting%2C%20soft%20shadows%2C%20editorial%20product%20photography%20style&width=800&height=500&seq=mogu-article-cover-01&orientation=landscape',
    readingTime: 5,
    publishDate: '2026-08-05',
    author: '蘑菇视频官方',
    tags: ['安卓下载', '安装教程', 'APK安装'],
  },
  {
    id: 'article-2',
    slug: 'mogushipin-ios-install-tutorial',
    title: '蘑菇视频App苹果iOS版下载安装教程',
    excerpt: '手把手教你如何在iPhone/iPad上通过App Store下载安装蘑菇视频App，解决下载慢、无法下载等常见问题。',
    content: `<h2>iOS版下载前须知</h2>
<p>蘑菇视频App已正式上架苹果App Store，iOS用户可直接通过官方应用商店下载安装，无需越狱或使用第三方助手。</p>
<ul>
<li>要求系统版本：iOS 14.0及以上</li>
<li>设备兼容：iPhone 6s及以上、iPad Air 2及以上、iPod touch第7代及以上</li>
<li>所需存储空间：约180MB</li>
</ul>
<h2>App Store下载步骤</h2>
<p><strong>步骤一：</strong>打开iPhone/iPad上的App Store应用。</p>
<p><strong>步骤二：</strong>点击底部「搜索」标签，在搜索框中输入「蘑菇视频」。</p>
<p><strong>步骤三：</strong>在搜索结果中找到蘑菇视频App（请认准官方图标和开发者名称），点击「获取」按钮。</p>
<p><strong>步骤四：</strong>使用Face ID、Touch ID或输入Apple ID密码确认下载。</p>
<p><strong>步骤五：</strong>等待下载和安装自动完成，安装后在主屏幕即可看到蘑菇视频图标。</p>
<h2>iOS常见问题解答</h2>
<h3>App Store搜不到蘑菇视频？</h3>
<p>请检查以下几点：Apple ID地区是否为中国大陆；网络连接是否正常；是否输入了正确的搜索关键词。如仍无法找到，可尝试切换Wi-Fi或蜂窝网络后重新搜索。</p>
<h3>下载速度很慢怎么办？</h3>
<p>建议连接稳定的Wi-Fi网络下载。如果Wi-Fi速度慢，可尝试重启路由器或切换至5GHz频段Wi-Fi。</p>
<h3>提示「无法安装，请稍后重试」？</h3>
<p>检查iPhone存储空间是否充足（设置 → 通用 → iPhone存储空间）。如空间不足，清理一些不需要的应用或文件后重试。</p>`,
    category: 'download',
    categoryName: '下载安装',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20iPhone%20displaying%20a%20short%20video%20entertainment%20app%20homepage%20with%20bright%20colorful%20video%20thumbnails%2C%20clean%20white%20desk%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20product%20photography&width=800&height=500&seq=mogu-article-cover-02&orientation=landscape',
    readingTime: 4,
    publishDate: '2026-08-03',
    author: '蘑菇视频官方',
    tags: ['iOS下载', '苹果安装', 'App Store'],
  },
  {
    id: 'article-3',
    slug: 'mogushipin-newbie-quick-start',
    title: '蘑菇视频App新手快速上手指南',
    excerpt: '刚下载蘑菇视频App？这篇指南帮你5分钟了解核心操作，快速玩转短视频娱乐平台。',
    content: `<h2>注册与登录</h2>
<p>首次打开蘑菇视频App，您可以通过以下方式快速注册：</p>
<ul>
<li><strong>手机号注册：</strong>输入手机号获取验证码，设置昵称和密码即可完成注册</li>
<li><strong>第三方登录：</strong>支持微信、QQ、微博一键登录</li>
<li><strong>游客模式：</strong>不注册也可以浏览视频内容，但无法点赞、评论和关注</li>
</ul>
<h2>首页浏览</h2>
<p>登录后默认进入「推荐」页面，系统会根据您的观看偏好智能推荐视频内容：</p>
<ul>
<li><strong>上下滑动：</strong>在推荐流中上下滑动切换视频</li>
<li><strong>双击点赞：</strong>双击视频画面即可点赞</li>
<li><strong>右侧按钮：</strong>点赞、评论、分享、收藏功能一应俱全</li>
<li><strong>关注作者：</strong>点击头像旁的「+关注」按钮即可关注喜欢的内容创作者</li>
</ul>
<h2>搜索与发现</h2>
<p>点击顶部搜索栏，可以搜索感兴趣的视频内容、话题标签或创作者。蘑菇视频的智能搜索支持：</p>
<ul>
<li>关键词搜索（视频标题、话题标签）</li>
<li>热门话题推荐</li>
<li>分类浏览（搞笑、美食、旅游、音乐等）</li>
</ul>
<h2>个人中心</h2>
<p>点击底部「我」进入个人中心，可以：</p>
<ul>
<li>编辑个人资料（头像、昵称、简介）</li>
<li>查看获赞、粉丝和关注数量</li>
<li>管理收藏和观看历史</li>
<li>设置隐私和通知偏好</li>
</ul>`,
    category: 'tutorial',
    categoryName: '使用教程',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20person%20holding%20a%20smartphone%20showing%20a%20short%20video%20app%20interface%20with%20bright%20vivid%20colors%2C%20warm%20cozy%20room%20background%2C%20soft%20natural%20lighting%2C%20lifestyle%20photography%20style&width=800&height=500&seq=mogu-article-cover-03&orientation=landscape',
    readingTime: 6,
    publishDate: '2026-08-01',
    author: '蘑菇视频官方',
    tags: ['新手教程', '快速入门', '使用技巧'],
  },
  {
    id: 'article-4',
    slug: 'mogushipin-video-creation-tools',
    title: '蘑菇视频App创作工具完全指南',
    excerpt: '全面解析蘑菇视频内置的视频拍摄、剪辑、特效和美颜工具，助你轻松创作优质短视频内容。',
    content: `<h2>拍摄工具</h2>
<p>蘑菇视频内置了强大的拍摄工具，让您无需第三方应用即可完成高质量短视频拍摄：</p>
<ul>
<li><strong>多种拍摄模式：</strong>支持普通拍摄、分段拍摄、快拍和慢动作等多种模式</li>
<li><strong>滤镜实时预览：</strong>拍摄时可实时预览滤镜效果，支持100+精美滤镜</li>
<li><strong>美颜功能：</strong>智能美颜、瘦脸、大眼、磨皮等一键美颜功能</li>
<li><strong>倒计时拍摄：</strong>支持3秒/10秒倒计时，方便自拍和合影</li>
</ul>
<h2>剪辑工具</h2>
<p>蘑菇视频App内置的专业级剪辑工具涵盖以下功能：</p>
<ul>
<li><strong>裁剪与分割：</strong>精确裁剪视频长度，支持多段分割和拼接</li>
<li><strong>变速调节：</strong>支持0.5倍至4倍速的无级变速</li>
<li><strong>转场效果：</strong>40+种流畅转场动画效果</li>
<li><strong>文字贴纸：</strong>丰富的文字样式和动态贴纸库</li>
<li><strong>背景音乐：</strong>海量正版音乐库，支持音量调节和淡入淡出</li>
</ul>
<h2>特效中心</h2>
<p>蘑菇视频的特效库不断更新，涵盖以下类别：</p>
<ul>
<li><strong>AR特效：</strong>基于增强现实技术的互动特效</li>
<li><strong>分屏特效：</strong>创意多画面分屏模板</li>
<li><strong>动态滤镜：</strong>随音乐节奏变化的动态滤镜效果</li>
<li><strong>一键同款：</strong>使用热门视频同款特效模板</li>
</ul>`,
    category: 'features',
    categoryName: '功能特色',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20showing%20a%20video%20editing%20interface%20with%20colorful%20timeline%20tracks%20and%20creative%20tools%2C%20on%20a%20clean%20wooden%20desk%20with%20warm%20ambient%20light%2C%20editorial%20product%20photography&width=800&height=500&seq=mogu-article-cover-04&orientation=landscape',
    readingTime: 7,
    publishDate: '2026-07-28',
    author: '蘑菇视频官方',
    tags: ['创作工具', '视频剪辑', '特效', '美颜'],
  },
  {
    id: 'article-5',
    slug: 'mogushipin-hd-playback-settings',
    title: '蘑菇视频高清播放与画质设置详解',
    excerpt: '教你如何调整蘑菇视频App的播放画质，获得最佳观看体验，包括省流量模式、极速模式等实用设置。',
    content: `<h2>播放画质选项</h2>
<p>蘑菇视频App支持多种画质选项，满足不同网络环境下的观看需求：</p>
<ul>
<li><strong>智能模式（推荐）：</strong>根据当前网络状况自动切换最优画质</li>
<li><strong>1080P高清：</strong>Wi-Fi环境下推荐使用，画面清晰细腻</li>
<li><strong>720P标清：</strong>4G网络下平衡画质与流量的推荐选择</li>
<li><strong>480P流畅：</strong>网络不稳定时的流畅播放保障</li>
<li><strong>省流量模式：</strong>最低画质，最大限度节省移动数据流量</li>
</ul>
<h2>播放设置调整</h2>
<p>在任意视频播放页面，您可以进行以下设置：</p>
<ul>
<li>点击播放器右上角的「···」菜单</li>
<li>选择「画质」选项</li>
<li>根据当前网络状况和个人偏好选择合适的画质</li>
</ul>
<h2>全局播放设置</h2>
<p>进入「我」→「设置」→「播放设置」，可以进行全局默认配置：</p>
<ul>
<li><strong>移动网络默认画质：</strong>设置在4G/5G网络下的默认播放画质</li>
<li><strong>Wi-Fi默认画质：</strong>设置Wi-Fi环境下的默认播放画质</li>
<li><strong>自动播放：</strong>开启后，当前视频结束后自动播放下一个</li>
<li><strong>后台播放：</strong>允许App在后台继续播放视频音频</li>
</ul>`,
    category: 'features',
    categoryName: '功能特色',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20playing%20a%20high%20definition%20video%20with%20vibrant%20colors%2C%20showing%20playback%20settings%20menu%20overlay%2C%20dark%20cinematic%20background%20with%20warm%20accent%20lighting%2C%20tech%20product%20photography&width=800&height=500&seq=mogu-article-cover-05&orientation=landscape',
    readingTime: 4,
    publishDate: '2026-07-25',
    author: '蘑菇视频官方',
    tags: ['高清播放', '画质设置', '省流量'],
  },
  {
    id: 'article-6',
    slug: 'mogushipin-account-security',
    title: '蘑菇视频账号安全与隐私保护指南',
    excerpt: '了解如何保护您的蘑菇视频账号安全，包括密码管理、设备管理、隐私设置等重要内容。',
    content: `<h2>账号安全基础设置</h2>
<p>保护您的蘑菇视频账号安全，建议完成以下基础设置：</p>
<ul>
<li><strong>强密码设置：</strong>使用8位以上包含字母、数字和特殊字符的密码</li>
<li><strong>绑定手机号：</strong>绑定手机号可用于找回密码和接收安全提醒</li>
<li><strong>实名认证：</strong>完成实名认证可提升账号安全等级</li>
<li><strong>设置密保问题：</strong>选择只有您自己知道答案的密保问题</li>
</ul>
<h2>设备管理</h2>
<p>在「设置」→「账号与安全」→「设备管理」中，您可以：</p>
<ul>
<li>查看当前登录的所有设备</li>
<li>远程退出不认识的设备</li>
<li>设置新设备登录验证</li>
</ul>
<h2>隐私设置</h2>
<p>蘑菇视频提供丰富的隐私设置选项：</p>
<ul>
<li><strong>谁可以看我的作品：</strong>可选择公开、仅好友可见或私密</li>
<li><strong>谁可以评论我的视频：</strong>可选择所有人、仅互关好友或关闭评论</li>
<li><strong>谁可以给我发私信：</strong>可选择所有人、仅互关好友或关闭私信</li>
<li><strong>不让他人看到我的点赞：</strong>开启后，您的点赞记录仅自己可见</li>
<li><strong>黑名单管理：</strong>屏蔽不想互动的用户</li>
</ul>`,
    category: 'faq',
    categoryName: '常见问题',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20a%20security%20shield%20icon%20and%20privacy%20settings%20interface%2C%20clean%20modern%20design%20with%20warm%20gradient%20background%2C%20tech%20security%20concept%20photography&width=800&height=500&seq=mogu-article-cover-06&orientation=landscape',
    readingTime: 5,
    publishDate: '2026-07-20',
    author: '蘑菇视频官方',
    tags: ['账号安全', '隐私保护', '设备管理'],
  },
  {
    id: 'article-7',
    slug: 'mogushipin-content-recommendation',
    title: '蘑菇视频智能推荐算法揭秘',
    excerpt: '带你了解蘑菇视频的智能推荐系统如何工作，以及如何调教算法，获得更符合你口味的内容推荐。',
    content: `<h2>推荐系统基本原理</h2>
<p>蘑菇视频的智能推荐系统基于先进的机器学习算法，通过多维度数据分析为您推荐感兴趣的内容：</p>
<ul>
<li><strong>观看历史：</strong>分析您观看过的视频类型、时长和互动行为</li>
<li><strong>互动偏好：</strong>您点赞、评论、分享和收藏的内容类型</li>
<li><strong>搜索记录：</strong>您主动搜索的关键词和话题</li>
<li><strong>关注创作者：</strong>您关注的创作者的创作领域和风格</li>
</ul>
<h2>如何调教推荐算法</h2>
<p>想要获得更精准的内容推荐？试试以下方法：</p>
<ul>
<li><strong>不感兴趣：</strong>长按视频选择「不感兴趣」，系统会减少同类内容推荐</li>
<li><strong>积极互动：</strong>对喜欢的内容多点赞、评论和收藏</li>
<li><strong>关注优质创作者：</strong>关注您喜欢的创作者，系统会推荐更多相似创作者</li>
<li><strong>搜索感兴趣的话题：</strong>主动搜索您感兴趣的关键词和话题标签</li>
</ul>`,
    category: 'features',
    categoryName: '功能特色',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20visualization%20of%20AI%20algorithm%20and%20data%20flow%20with%20colorful%20connected%20nodes%2C%20warm%20orange%20and%20amber%20tones%2C%20technology%20concept%20art%20style&width=800&height=500&seq=mogu-article-cover-07&orientation=landscape',
    readingTime: 5,
    publishDate: '2026-07-15',
    author: '蘑菇视频官方',
    tags: ['推荐算法', '内容推荐', '个性化'],
  },
  {
    id: 'article-8',
    slug: 'mogushipin-vip-membership',
    title: '蘑菇视频VIP会员权益全解析',
    excerpt: '蘑菇视频VIP会员有哪些专属权益？开通方式、价格和实用技巧一文讲透。',
    content: `<h2>VIP会员专属权益</h2>
<p>开通蘑菇视频VIP会员，即可享受以下专属权益：</p>
<ul>
<li><strong>免广告观看：</strong>观看视频时自动跳过所有广告，享受沉浸式体验</li>
<li><strong>超清画质：</strong>解锁4K超高清画质选项</li>
<li><strong>专属滤镜和特效：</strong>VIP用户独享100+高级滤镜和特效模板</li>
<li><strong>优先客服：</strong>享受VIP专属客服通道，问题快速响应</li>
<li><strong>身份标识：</strong>评论区、个人主页展示尊贵VIP标识</li>
<li><strong>更大云存储：</strong>VIP用户享10GB专属云存储空间</li>
</ul>
<h2>开通方式</h2>
<ul>
<li><strong>月卡：</strong>适合短期体验，每月自动续费</li>
<li><strong>季卡：</strong>三个月套餐，比月卡更优惠</li>
<li><strong>年卡：</strong>年度套餐，价格最优，附赠额外权益</li>
</ul>`,
    category: 'features',
    categoryName: '功能特色',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20luxurious%20golden%20VIP%20membership%20card%20concept%20with%20a%20smartphone%20displaying%20premium%20app%20features%2C%20elegant%20dark%20background%20with%20warm%20golden%20accents%2C%20premium%20lifestyle%20photography&width=800&height=500&seq=mogu-article-cover-08&orientation=landscape',
    readingTime: 5,
    publishDate: '2026-07-10',
    author: '蘑菇视频官方',
    tags: ['VIP会员', '会员权益', '开通指南'],
  },
  {
    id: 'article-9',
    slug: 'mogushipin-video-download',
    title: '蘑菇视频视频下载与离线观看方法',
    excerpt: '教你如何在蘑菇视频App中下载喜欢的视频到本地，随时随地离线观看。',
    content: `<h2>视频下载步骤</h2>
<p>蘑菇视频App支持将视频下载到本地，方便离线观看：</p>
<ul>
<li><strong>步骤一：</strong>打开想要下载的视频</li>
<li><strong>步骤二：</strong>点击右侧「分享」按钮</li>
<li><strong>步骤三：</strong>在弹出的菜单中点击「保存到本地」</li>
<li><strong>步骤四：</strong>选择下载画质（高清/标清/流畅）</li>
<li><strong>步骤五：</strong>等待下载完成，在「我」→「离线缓存」中查看</li>
</ul>
<h2>离线观看管理</h2>
<ul>
<li>进入「我」→「离线缓存」查看所有已下载的视频</li>
<li>支持批量删除已下载的视频以释放存储空间</li>
<li>部分版权内容可能不支持下载，请以实际显示为准</li>
</ul>`,
    category: 'faq',
    categoryName: '常见问题',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20showing%20a%20download%20progress%20interface%20with%20video%20thumbnails%2C%20on%20a%20warm%20wooden%20surface%20with%20coffee%20cup%2C%20cozy%20lifestyle%20photography&width=800&height=500&seq=mogu-article-cover-09&orientation=landscape',
    readingTime: 3,
    publishDate: '2026-07-05',
    author: '蘑菇视频官方',
    tags: ['视频下载', '离线观看', '本地缓存'],
  },
  {
    id: 'article-10',
    slug: 'mogushipin-livestream-guide',
    title: '蘑菇视频直播功能使用全攻略',
    excerpt: '从开播设置到互动技巧，全面了解蘑菇视频App直播功能的方方面面。',
    content: `<h2>如何开启直播</h2>
<p>在蘑菇视频App中开启直播非常简单：</p>
<ul>
<li><strong>开播条件：</strong>完成实名认证且账号无违规记录</li>
<li><strong>开播步骤：</strong>点击底部「+」→ 选择「开直播」→ 设置直播封面和标题 → 点击「开始直播」</li>
</ul>
<h2>直播互动功能</h2>
<ul>
<li><strong>实时弹幕：</strong>观众发送的弹幕实时显示在直播画面中</li>
<li><strong>礼物系统：</strong>观众赠送的虚拟礼物以特效形式展示</li>
<li><strong>连麦互动：</strong>支持与观众语音或视频连麦</li>
<li><strong>直播间管理：</strong>可设置管理员协助维护直播间秩序</li>
</ul>`,
    category: 'tutorial',
    categoryName: '使用教程',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20showing%20a%20live%20streaming%20interface%20with%20colorful%20gift%20animations%20and%20chat%20messages%2C%20vibrant%20entertainment%20atmosphere%2C%20dynamic%20lighting%2C%20social%20media%20concept&width=800&height=500&seq=mogu-article-cover-10&orientation=landscape',
    readingTime: 6,
    publishDate: '2026-06-28',
    author: '蘑菇视频官方',
    tags: ['直播', '开播指南', '互动功能'],
  },
  {
    id: 'article-11',
    slug: 'mogushipin-parental-control',
    title: '蘑菇视频青少年模式与家长控制设置',
    excerpt: '了解蘑菇视频的青少年保护机制，包括青少年模式、时间管理和内容过滤等功能。',
    content: `<h2>开启青少年模式</h2>
<p>进入「我」→「设置」→「青少年模式」，设置密码后即可开启：</p>
<ul>
<li><strong>内容过滤：</strong>自动过滤不适合青少年观看的内容</li>
<li><strong>使用时长限制：</strong>每日累计使用40分钟后需要输入密码</li>
<li><strong>宵禁功能：</strong>每日22:00至次日6:00无法使用App</li>
<li><strong>关闭打赏：</strong>青少年模式下自动关闭直播打赏功能</li>
<li><strong>限制私信：</strong>禁止陌生人私信，保护青少年社交安全</li>
</ul>
<h2>家长远程管理</h2>
<p>家长可通过绑定「家庭守护」功能，远程管理孩子的使用情况：</p>
<ul>
<li>查看每日使用时长报告</li>
<li>远程设置可用时间段</li>
<li>管理内容偏好</li>
</ul>`,
    category: 'faq',
    categoryName: '常见问题',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20a%20parental%20control%20settings%20interface%20with%20shield%20icon%2C%20warm%20family%20living%20room%20background%2C%20soft%20natural%20lighting%2C%20safety%20concept%20photography&width=800&height=500&seq=mogu-article-cover-11&orientation=landscape',
    readingTime: 5,
    publishDate: '2026-06-20',
    author: '蘑菇视频官方',
    tags: ['青少年模式', '家长控制', '安全使用'],
  },
  {
    id: 'article-12',
    slug: 'mogushipin-troubleshooting',
    title: '蘑菇视频常见故障排查与解决方案',
    excerpt: '汇总蘑菇视频App使用中的常见故障及其解决方法，包括闪退、加载失败、播放卡顿等问题。',
    content: `<h2>App闪退或无法启动</h2>
<ul>
<li><strong>解决方案一：</strong>清除应用缓存（设置 → 应用管理 → 蘑菇视频 → 清除缓存）</li>
<li><strong>解决方案二：</strong>检查手机系统版本是否满足最低要求</li>
<li><strong>解决方案三：</strong>卸载后从官方渠道重新下载安装最新版本</li>
</ul>
<h2>视频加载缓慢或无法播放</h2>
<ul>
<li><strong>检查网络：</strong>切换Wi-Fi/4G网络，确认网络连接正常</li>
<li><strong>降低画质：</strong>在播放设置中选择较低画质</li>
<li><strong>清理缓存：</strong>进入设置清理App缓存文件</li>
</ul>
<h2>登录失败或账号异常</h2>
<ul>
<li><strong>检查网络：</strong>确保网络连接正常</li>
<li><strong>重置密码：</strong>通过绑定的手机号重置密码</li>
<li><strong>联系客服：</strong>如以上方法无效，请联系官方客服</li>
</ul>`,
    category: 'faq',
    categoryName: '常见问题',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20showing%20a%20technical%20error%20troubleshooting%20screen%20with%20fix%20icons%2C%20clean%20tech%20support%20concept%2C%20warm%20professional%20lighting%2C%20help%20desk%20photography&width=800&height=500&seq=mogu-article-cover-12&orientation=landscape',
    readingTime: 4,
    publishDate: '2026-06-15',
    author: '蘑菇视频官方',
    tags: ['故障排查', '问题解决', '技术支持'],
  },
];

export const featuredArticles = ['article-1', 'article-3', 'article-4', 'article-6'];